import { render, staticRenderFns } from "./ScheduleBoard.vue?vue&type=template&id=791a1cce&scoped=true&"
import script from "./ScheduleBoard.vue?vue&type=script&lang=ts&"
export * from "./ScheduleBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleBoard.vue?vue&type=style&index=0&id=791a1cce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a1cce",
  null
  
)

export default component.exports